import { render, staticRenderFns } from "./btn-quarternary.vue?vue&type=template&id=26c22464&scoped=true&"
import script from "./btn-quarternary.vue?vue&type=script&lang=js&"
export * from "./btn-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c22464",
  null
  
)

export default component.exports